module.exports = __webpack_public_path__ + "static/media/C31.a06fbfe6.png";